import { blenderCss } from '@clds/blender';
export const getBlendMode = (selectionVariant, isSelected, variant) => {
    if (isSelected) {
        return selectionVariant === 'solid' ? 'solidContrast' : 'plainSolid';
    }
    return variant === 'primary' ? 'surfaceContrast' : 'plainSolid';
};
const intensityByState = {
    normal: 'md',
    hover: 'sm',
    selected: 'lg',
    selectedHover: 'xl',
};
export const populateBlenderVariablesForState = (state) => ({ variant, selectionVariant, isSelected, }) => {
    const mode = getBlendMode(selectionVariant, isSelected, variant);
    return blenderCss.populateVariables({
        mode,
        variant,
        intensity: intensityByState[state],
    });
};
